import { DetailAction } from '../../detail/actions/DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { EpgApi } from '../../../api/EpgApi';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { Backend } from '../../../api/Backend';
import { OptionData } from '../../../components/option/OptionData';
import { ICategory } from '../../../api/models/AndromeTV.types';

export class ListTagFilterActionHandler extends DetailAction {
  private filterState: FilterState;
  constructor(backend: Backend, filterState: FilterState) {
    super(backend);
    this.filterState = filterState;
  }

  override doAction() {
    EpgApi.categories(this._backend).then(data => {
      const filteredData = this.removeAdult(data);
      const selected = this.filterState.stateOf(listFilterType.tag);
      const options = filteredData?.map(cat => this._optionFromCategory([], cat, selected));
      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
        },
      });
    });
  }

  _optionFromCategory(parentTags: string[], cat: ICategory, selected: any) {
    const result: OptionData = { options: [], value: undefined };
    const hasChildren = cat.subcategories && cat.subcategories.length > 0;
    const postfix = hasChildren ? ' >' : '';
    result.text = cat.title + postfix;
    result.selected = selected && selected.value.includes(cat.tag);
    result.value = [...parentTags, cat.tag];
    if (hasChildren) {
      result.options = cat.subcategories?.map(c => this._optionFromCategory(result.value, c, selected)) || [];
    }
    return result;
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.tag, option.text, option.value);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  /**
   * filter out all adult pages
   * @param {ICategory[]} itemsArr
   * @return ICategory[]
   */
  removeAdult(itemsArr: ICategory[] | undefined): ICategory[] | undefined {
    if (!itemsArr || itemsArr.length === 0) return undefined;
    const returnVal = itemsArr.map(item => {
      if (item.adult) return undefined;
      item.subcategories = this.removeAdult(item.subcategories);
      return item;
    });
    return returnVal.filter(el => el) as ICategory[];
  }
}
